var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamBatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 39,
    viewBox: "0 0 35 39",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6113 23.5748V38.4499C10.6113 38.5456 10.6361 38.6396 10.6834 38.7228C10.7308 38.8059 10.7989 38.8753 10.8812 38.9242C10.9635 38.973 11.0571 38.9995 11.1528 39.0012C11.2484 39.0028 11.3429 38.9796 11.4268 38.9336L17.2236 35.7713L23.0203 38.9336C23.1042 38.9796 23.1987 39.0028 23.2944 39.0012C23.39 38.9995 23.4836 38.973 23.5659 38.9242C23.6482 38.8753 23.7164 38.8059 23.7637 38.7228C23.811 38.6396 23.8359 38.5456 23.8358 38.4499V23.5748C23.8358 22.9904 23.6036 22.4298 23.1903 22.0165C22.7769 21.6033 22.2163 21.3711 21.6317 21.3711H12.8154C12.2309 21.3711 11.6702 21.6033 11.2569 22.0165C10.8435 22.4298 10.6113 22.9904 10.6113 23.5748Z",
    fill: "current"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3836_38005)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.225,
    cy: 16.2244,
    rx: 6.61224,
    ry: 6.61116,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6413 4.43847C20.1963 3.98312 19.6648 3.62131 19.078 3.37428C18.4913 3.12725 17.861 3 17.2244 3C16.5877 3 15.9575 3.12725 15.3707 3.37428C14.7839 3.62131 14.2525 3.98312 13.8075 4.43847L12.7793 5.49311L11.3081 5.47493C10.6712 5.46739 10.0393 5.58727 9.44947 5.8275C8.85964 6.06774 8.32379 6.42349 7.87344 6.87383C7.42309 7.32418 7.06734 7.86002 6.8271 8.44985C6.58686 9.03968 6.46699 9.6716 6.47452 10.3084L6.49105 11.7796L5.43971 12.8078C4.98436 13.2528 4.62253 13.7843 4.3755 14.371C4.12847 14.9578 4.00122 15.588 4.00122 16.2247C4.00122 16.8613 4.12847 17.4916 4.3755 18.0783C4.62253 18.6651 4.98436 19.1966 5.43971 19.6415L6.49271 20.6697L6.47452 22.1409C6.46699 22.7778 6.58686 23.4097 6.8271 23.9995C7.06734 24.5893 7.42309 25.1252 7.87344 25.5755C8.32379 26.0259 8.85964 26.3816 9.44947 26.6219C10.0393 26.8621 10.6712 26.982 11.3081 26.9744L12.7793 26.9579L13.8075 28.0092C14.2525 28.4646 14.7839 28.8264 15.3707 29.0734C15.9575 29.3205 16.5877 29.4477 17.2244 29.4477C17.861 29.4477 18.4913 29.3205 19.078 29.0734C19.6648 28.8264 20.1963 28.4646 20.6413 28.0092L21.6695 26.9562L23.1407 26.9744C23.7775 26.982 24.4094 26.8621 24.9993 26.6219C25.5891 26.3816 26.125 26.0259 26.5753 25.5755C27.0257 25.1252 27.3814 24.5893 27.6217 23.9995C27.8619 23.4097 27.9818 22.7778 27.9742 22.1409L27.9577 20.6697L29.0091 19.6415C29.4644 19.1966 29.8262 18.6651 30.0733 18.0783C30.3203 17.4916 30.4475 16.8613 30.4475 16.2247C30.4475 15.588 30.3203 14.9578 30.0733 14.371C29.8262 13.7843 29.4644 13.2528 29.0091 12.8078L27.9561 11.7796L27.9742 10.3084C27.9818 9.6716 27.8619 9.03968 27.6217 8.44985C27.3814 7.86002 27.0257 7.32418 26.5753 6.87383C26.125 6.42349 25.5891 6.06774 24.9993 5.8275C24.4094 5.58727 23.7775 5.46739 23.1407 5.47493L21.6695 5.49146L20.6413 4.43847ZM21.1157 14.3303L16.1565 19.2894C16.0797 19.3664 15.9885 19.4275 15.8881 19.4691C15.7877 19.5108 15.68 19.5322 15.5713 19.5322C15.4626 19.5322 15.355 19.5108 15.2545 19.4691C15.1541 19.4275 15.0629 19.3664 14.9861 19.2894L12.5065 16.8099C12.4297 16.733 12.3687 16.6418 12.3271 16.5414C12.2856 16.441 12.2642 16.3334 12.2642 16.2247C12.2642 16.116 12.2856 16.0084 12.3271 15.908C12.3687 15.8076 12.4297 15.7163 12.5065 15.6395C12.5834 15.5627 12.6746 15.5017 12.775 15.4601C12.8754 15.4185 12.983 15.3971 13.0917 15.3971C13.2004 15.3971 13.308 15.4185 13.4084 15.4601C13.5088 15.5017 13.6001 15.5627 13.6769 15.6395L15.5713 17.5355L19.9453 13.1599C20.1005 13.0047 20.311 12.9175 20.5305 12.9175C20.75 12.9175 20.9605 13.0047 21.1157 13.1599C21.2709 13.3151 21.3581 13.5256 21.3581 13.7451C21.3581 13.9646 21.2709 14.1751 21.1157 14.3303Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3836_38005",
    x: 0,
    y: 0,
    width: 34.449,
    height: 34.4492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3836_38005"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3836_38005",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamBatch);
export default __webpack_public_path__ + "static/media/TeamBatch.21b01ae7e57a0c86c5096432d9004c58.svg";
export { ForwardRef as ReactComponent };